import $x from '@/utils/$x';

// 添加内容
export async function addLittaContentPool(params) {
  return $x.post('/xplancontent/addLittaContentPool', params);
}

// 更新内容
export async function updateXplanContent(params) {
  return $x.post('/xplancontent/updateXplanContent', params);
}

// 上下线内容
export async function enableOrDisableXplanContent(params) {
  return $x.post('/xplancontent/enableOrDisableXplanContent', params);
}

// 分页查询内容列表
export async function getXplanContentPage(params) {
  return $x.post('/xplancontent/getXplanContentPage', params);
}

// 查询内容详情
export async function getXplanContentById(params) {
  return $x.post('/xplancontent/getXplanContentById', params);
}

//  根据id删除内容
export async function deleteXplanContent(params) {
  return $x.post('/xplancontent/deleteXplanContent', params);
}


/**
 *  品类
 */

//  查询品类树
export async function getCategoryTree(params) {
  return $x.post('/category/getLittaCategoryTree', params);
}

//  根据id查品类详情
export async function getLittaCategoryById(params) {
  return $x.post('/category/getLittaCategoryById', params);
}

// 根据一级分类的id获取绑定渠道
export async function getChannelByCategoryId(params) {
  return $x.post('/contentChannel/getChannelByCategoryId', params);
}

// 替换视频
export async function updatePlaybackUrl(params) {
  return $x.post('/xplancontent/updateMediaContent', params);
}

// 编辑分类介绍
export async function editLittaCategoryIntro(params) {
  return $x.post('/category/editLittaCategoryIntro', params);
}
